module.exports = __webpack_public_path__ + "static/media/excel_icon.c2c2014a.webp";